module.exports = __webpack_public_path__ + "img/fs2.7625e441.png";